// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"5045d376","453":"de48d205","535":"9f101d8c","931":"651cd265"}[chunkId] + ".chunk.js";
};